export const PAYMENT_TYPE = {
	NONE: -1,
	CASH: 0, // Cash payment
	CREDIT: 1, // Credit payment
	CHECK: 2, // Personal check payment. Not yet supported.
	CHEQUE_REPAS: 3, // Welfare payment. Not yet supported.
	GIFT_CARD: 4, // Giftcard payment. Not yet supported.
	TAB: 5, // Tab payment. Not yet supported.
	CASH_REFUND: 6, // Refund of cash.
	CREDIT_REFUND: 7, // Refund of credit.
	LOYALTY: 8, // Loyalty points payment
	LOYALTY_REFUND: 9, // Refund of loyalty points to a customer
	OTHER: 10, // Cash-equivalent payment
	OTHER_REFUND: 11, // Cash-equivalent refund
	TP_GIFT_CARD: 12, // Internal Gift Card
	TP_GIFT_CARD_REFUND: 13, // Internal Gift Card refund
	COD: 14, // Cash on Delivery
} as const;
export type TPaymentType = typeof PAYMENT_TYPE[keyof typeof PAYMENT_TYPE];

export const PAYMENT_TYPE_LABELS: Record<TPaymentType, string> = {
	[PAYMENT_TYPE.NONE]: 'none',
	[PAYMENT_TYPE.CASH]: 'Cash',
	[PAYMENT_TYPE.CREDIT]: 'Credit',
	[PAYMENT_TYPE.CHECK]: 'Check',
	[PAYMENT_TYPE.CHEQUE_REPAS]: 'ECB',
	[PAYMENT_TYPE.GIFT_CARD]: 'Gift Card',
	[PAYMENT_TYPE.TAB]: 'Tab',
	[PAYMENT_TYPE.CASH_REFUND]: 'Cash Refund',
	[PAYMENT_TYPE.CREDIT_REFUND]: 'Credit Refund',
	[PAYMENT_TYPE.LOYALTY]: 'Loyalty Points',
	[PAYMENT_TYPE.LOYALTY_REFUND]: 'Loyalty Points Refund',
	[PAYMENT_TYPE.OTHER]: 'Other',
	[PAYMENT_TYPE.OTHER_REFUND]: 'Other refund',
	[PAYMENT_TYPE.TP_GIFT_CARD]: 'Gift Card',
	[PAYMENT_TYPE.TP_GIFT_CARD_REFUND]: 'Gift Card Refund',
	[PAYMENT_TYPE.COD]: 'Cash on Delivery',
};
